import type { VdbPath } from '@/lib/useVdb';

/** What Find Path found, in the names the canvas shows: each step as the two
 *  things it joins and the relationship between them. */
export function pathSummary(path: VdbPath, fromName: string, toName: string): string {
  const names = new Map(path.nodes.map((uri, i) => [uri, path.node_labels[i] ?? uri]));
  const steps = path.edges.map(
    (e) => `${names.get(e.source) ?? e.source} ${e.label} ${names.get(e.target) ?? e.target}`,
  );
  const count = `${path.total_length} step${path.total_length === 1 ? '' : 's'}`;
  return steps.length > 0
    ? `Path from ${fromName} to ${toName}, ${count}: ${steps.join('; ')}.`
    : `Path from ${fromName} to ${toName}, ${count}.`;
}
